import type { CapturedRequestHeaders } from './useIndeedConfig.types';
import { browserExtensionClient } from 'clients/BrowserExtensionClient/BrowserExtensionClient';

export const extractCookieValue = (cookieStr: string, name: string): string => {
  const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const m = cookieStr.match(new RegExp(`(?:^|;\\s*)${escapedName}=([^;]+)`));
  return m ? decodeURIComponent(m[1]) : '';
};

export const extractCookieFromHeaders = (headersMap: Record<string, string>): string => {
  return headersMap.Cookie ?? headersMap.cookie ?? '';
};

export const extractCtkFromHeaders = (headersMap: Record<string, string>, cookieStr: string): string => {
  return headersMap['indeed-ctk'] ?? extractCookieValue(cookieStr, 'CTK') ?? '';
};

export const getCapturedRequestHeaders = async (): Promise<CapturedRequestHeaders | null> => {
  const { value } = await browserExtensionClient.sendMessage('readLocalStorage', {
    key: 'capturedRequestHeaders',
  });

  if (!value) return null;

  const parsed = JSON.parse(value as string);
  const headersArray = parsed.headers as { name: string; value: string }[];

  return {
    headersMap: Object.fromEntries(headersArray.map((h) => [h.name, h.value])),
    capturedAt: parsed.capturedAt,
  };
};
